import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import AppShell, { NAV } from "@/components/layout/AppShell";
import LoginPage from "@/pages/LoginPage";
import DashboardPage from "@/pages/DashboardPage";
import StoresPage from "@/pages/StoresPage";
import DCsPage from "@/pages/DCsPage";
import ProductsPage from "@/pages/ProductsPage";
import PlaceOrderPage from "@/pages/PlaceOrderPage";
import WarehousePage from "@/pages/WarehousePage";
import HistoryPage from "@/pages/HistoryPage";
import OrderDetailPage from "@/pages/OrderDetailPage";
import ApprovalsPage from "@/pages/ApprovalsPage";
import ForecastingPage from "@/pages/ForecastingPage";
import ReportsPage from "@/pages/ReportsPage";
import ImportPage from "@/pages/ImportPage";
import UsersPage from "@/pages/UsersPage";
import NotificationsPage from "@/pages/NotificationsPage";
import OraclePage from "@/pages/OraclePage";

const PAGES = { "/": DashboardPage, "/order": PlaceOrderPage, "/history": HistoryPage, "/approvals": ApprovalsPage, "/products": ProductsPage, "/warehouse": WarehousePage, "/stores": StoresPage, "/dcs": DCsPage, "/forecasting": ForecastingPage, "/reports": ReportsPage, "/import": ImportPage, "/users": UsersPage, "/notifications": NotificationsPage, "/oracle": OraclePage };

function Protected() {
  const { user } = useAuth();
  if (user === null) return <div className="flex min-h-screen items-center justify-center bg-[#F6F7F9]"><div className="h-8 w-8 animate-spin rounded-full border-[3px] border-slate-200 border-t-red-600" /></div>;
  if (!user) return <Navigate to="/login" replace />;
  return <AppShell />;
}

function RoleRoute({ path, Component }) {
  const { user } = useAuth();
  const item = NAV.find((n) => n.to === path);
  if (item && !item.roles.includes(user.role)) return <Navigate to="/" replace />;
  return <Component />;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route element={<Protected />}>
            {Object.entries(PAGES).map(([p, C]) => <Route key={p} path={p} element={<RoleRoute path={p} Component={C} />} />)}
            <Route path="/orders/:id" element={<OrderDetailPage />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors closeButton />
    </AuthProvider>
  );
}

export default App;
